import { jsx as _jsx } from "react/jsx-runtime";
import { useLocalizeMessage } from 'libs.nucleus';
import { PageWrapper } from 'libs.react';
export const ConsentRoleDenied = () => {
    const translate = useLocalizeMessage();
    return (_jsx(PageWrapper, { children: _jsx("p", { "data-testid": 'consent-role-denied', children: translate('This document is not available to your role.') }) }));
};
